import { Component, OnInit, ElementRef } from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { AuthService, CandidatesService } from '../../services';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
    private toggleButton: any;
    private sidebarVisible: boolean;
    currentUser = null;
    constructor(private toastr: ToastrService, public location: Location, private element : ElementRef, private authService: AuthService,private router: Router, private candidateService: CandidatesService) {
        this.sidebarVisible = false;
        this.authService.valueSource.subscribe(user => this.currentUser = user);
    }

    ngOnInit() {
        this.authService.getCandidateInfo().subscribe((res:any) =>{
            
            this.authService.user = res.data;
            this.authService.valueSource.subscribe(user => this.currentUser = user);
            this.currentUser = res.data;
            console.trace(this.currentUser);
        },error=>{
            
        })
        const navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
        this.currentUser = this.authService.user;
    }
    sidebarOpen() {
        const toggleButton = this.toggleButton;
        const html = document.getElementsByTagName('html')[0];
        
        

        setTimeout(function(){
            toggleButton.classList.add('toggled');
        }, 500);
        html.classList.add('nav-open');

        this.sidebarVisible = true;
    };
    sidebarClose() {
        const html = document.getElementsByTagName('html')[0];
        
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        html.classList.remove('nav-open');
    };
    sidebarToggle() {
        // const toggleButton = this.toggleButton;
        // const body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible === false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    };
    isHome() {
      var titlee = this.location.prepareExternalUrl(this.location.path());
      if(titlee.charAt(0) === '#'){
          titlee = titlee.slice( 1 );
      }
        if( titlee === '/home' ) {
            return true;
        }
        else {
            return false;
        }
    }
    isWhatWeOffer() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if(titlee.charAt(0) === '#'){
            titlee = titlee.slice( 1 );
        }
          if( titlee === '/what-we-offer' ) {
              return true;
          }
          else {
              return false;
          }
    };
    logout(){
        localStorage.setItem('auth_app_token', JSON.stringify(null));
        this.currentUser = null;
        this.router.navigate(['/']);
    }
    sendActivationEmail(){
        this.candidateService.activateEmail(this.authService.user.candidate?.id).subscribe((res: any) =>{
            this.toastr.success("Kindly check your mail inbox","Activate Account");
        },(error: any)=>{
            this.toastr.error("You'r Email is not valid Or try again later!","Activate Account");
        });
    }
}
